module.exports = __webpack_public_path__ + "fonts/Noto_Sans_SC-300-46.08b44db.woff2";